// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ModalUpdateLocation_wrapper__2zOZL","buttonAction":"ModalUpdateLocation_buttonAction__2M-gH"};